import { message } from "antd";
import { createNewAdmin, onChangeStatusEnterpise, onCreateProject, onGetAllEnterpriseds, onNewEnterpise } from "../../api";
import { addEnterprises, deleteOneEnterpise } from "./adminInmersysSlice";

export const addNewEnterpriseAndAdmin = (payload) => {
	return async (dispatch, getState) => {
		const enterprisedCreated = await onNewEnterpise("https://cdn.2020prosoftware.com/installations/common/img/image-not-found.png", payload.name);
		if (enterprisedCreated.status === 0) {
			message.success("Empresa credada con exito");
			const newAdmin = await createNewAdmin({
				userName: payload.userName,
				email: payload.email,
				password: payload.password,
				enterpriseId: enterprisedCreated.payload._id,
				typeUser: payload.typeUser,
			});
			if (newAdmin.status === 0) {
				message.success("Administrador creado con exito");
			} else {
				message.error(newAdmin.payload[0].msg);
				return false;
			}
			//
			const response = await onCreateProject(payload.nameProyect, enterprisedCreated.payload._id);
			if (response.status === 0) {
				message.success("Proyecto creado");
				return true;
			} else {
				message.error("error al crear proyecto");
				return false;
			}
			//
		} else {
			console.log(enterprisedCreated);
			message.error(enterprisedCreated.payload[0].msg);
			return false;
		}
	};
};
export const getAllEnterpiseds = (payload) => {
	return async (dispatch, getState) => {
		const response = await onGetAllEnterpriseds();
		if (response.status === 0) {
			dispatch(addEnterprises(response.payload.enterprises));
		} else {
			message.error(response.payload[0].msg);
			return false;
		}
	};
};

export const ChangeStatusEnterprise = (idEnterpise) => {
	return async (dispatch, getState) => {
		const response = await onChangeStatusEnterpise(idEnterpise);
		if (response.status === 0) {
			dispatch(deleteOneEnterpise({ id: idEnterpise }));
			message.success("Eliminado");
		} else {
			message.error(response.payload[0].msg);
			return false;
		}
	};
};
